import { render, staticRenderFns } from "./Documents.vue?vue&type=template&id=a3f657b0"
import script from "./Documents.vue?vue&type=script&lang=js"
export * from "./Documents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a3f657b0')) {
      api.createRecord('a3f657b0', component.options)
    } else {
      api.reload('a3f657b0', component.options)
    }
    module.hot.accept("./Documents.vue?vue&type=template&id=a3f657b0", function () {
      api.rerender('a3f657b0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/provider/trainingHistory/components/Documents.vue"
export default component.exports